import { createAction, props } from '@ngrx/store';
import { GetDistributorsPublicParams, GetDistributorsResponse } from 'src/app/core/proto';

export enum DistributorsActionTypes {
  DistributorNamesListGet = '[Distributors] Distributor Names List Get',
  DistributorNamesListGetSuccess = '[Distributors] Distributor Names List Get Success',
  DistributorNamesListGetFailure = '[Distributors] Distributor Names List Get Failure',
}

// DistributorNamesList
export const actionDistributorNamesListGet = createAction(
  DistributorsActionTypes.DistributorNamesListGet,
  props<{ body: GetDistributorsPublicParams }>()
);

export const actionDistributorNamesListGetSuccess = createAction(
  DistributorsActionTypes.DistributorNamesListGetSuccess,
  props<{ payload?: GetDistributorsResponse }>()
);

export const actionDistributorNamesListGetFailure = createAction(
  DistributorsActionTypes.DistributorNamesListGetFailure
);
